// Session recovery (query-cache clear + guard re-run) must fire only when the
// backend says the session itself is gone. These are the stable codes its auth
// middleware attaches to that verdict, on both the `/auth` and
// `/backoffice-auth` namespaces. Every other 401 code is a failed credential
// attempt the caller handles locally — wrong password, bad email code,
// invalid impersonation token — so new credential-checking endpoints need no
// registration here: their failure codes are simply not in this set.
const SESSION_DEATH_CODES = new Set([
	'auth_credentials_missing',
	'auth_jwt_invalid',
	'session_invalid',
	'session_expired',
	'user_deleted',
	'backoffice_auth_credentials_missing',
	'backoffice_jwt_invalid',
	'backoffice_session_invalid',
	'backoffice_session_expired',
	'backoffice_admin_deleted'
])

export function isSessionDeathCode(code: string | undefined) {
	return code !== undefined && SESSION_DEATH_CODES.has(code)
}
